import styles from './logoInformationText.module.css';
const LogoInformationText = ({ children }) => {

    return (
        <div className={styles.container}>
            <div className={styles.logoContainer}>
                <img
                    src={`/images/logo.png`}
                    alt="TuS05-Logo" />
            </div>
            <div className={styles.textContainer}>
                {children && (children)}
            </div>

        </div>
    );
}
export default LogoInformationText;